// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__39HmY","container":"styles_container__28ZA3","title":"styles_title__2Mnm1","wrapper":"styles_wrapper__1nH3n","answer":"styles_answer__1EsJG"};